import SectionHeading from "@/components/base/SectionHeading";
import { standards } from "@/pages/home/data";

export default function StandardsSection() {
  return (
    <section id="standards" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="审核标准"
            title="黑料投稿审核标准：六项必须同时通过"
            description="每条投稿都会依次对照下列六项标准。任一项不达标即进入“待补充”或“不予发布”状态，并标明具体对应条款。"
          />
          <a
            href="#contact"
            className="shrink-0 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-600 text-background-50 text-sm font-medium hover:bg-secondary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-question-answer-line" aria-hidden="true"></i>
            投稿前先咨询
          </a>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {standards.map((item, i) => (
            <article
              key={item.title}
              className="group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 text-xl ring-1 ring-primary-100">
                  <i className={item.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-400">
                  标准 {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-8 text-sm leading-relaxed text-foreground-500">
          说明：审核标准会随法律法规与行业规范持续更新；涉及未成年人、医疗记录与未生效司法结论的内容，无论证据是否充分均不予发布。
        </p>
      </div>
    </section>
  );
}